import { lazy, Suspense } from 'react'
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router'

import { AppHeader } from '@/components/app-header'

// Router devtools are loaded lazily and stripped from production builds.
const RouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((module) => ({
        default: module.TanStackRouterDevtools,
      })),
    )

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  const isChat = useRouterState({
    select: (state) => state.location.pathname === '/chat',
  })

  if (isChat) {
    return (
      <div className="h-full bg-background text-foreground">
        <Outlet />
        <Suspense fallback={null}>
          <RouterDevtools position="bottom-left" />
        </Suspense>
      </div>
    )
  }

  return (
    <div className="flex h-full flex-col bg-background text-foreground">
      <AppHeader />
      <main className="min-h-0 flex-1">
        <Outlet />
      </main>
      <Suspense fallback={null}>
        <RouterDevtools position="bottom-left" />
      </Suspense>
    </div>
  )
}
